import { GetterTree } from "vuex";
import { AppState } from "./index";
import { RootState } from "../index";
import { UserModel } from "@/models/usermodel";

export const getters: GetterTree<AppState, RootState> = {
  isAuthenticated(state): boolean {
    return state.authenticated;
  },
  getUserProfile(state): UserModel | {} {
    return state.userprofile;
  },
};
